module.exports = __webpack_public_path__ + "img/menu.03dc68d7.svg";